import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import * as R from 'ramda';

import {config} from '@/config';
import {SystemConfigCtx} from '@/contexts';
import MainSiteLink from '@/components/MainSiteLink';
import * as supportLink from '@/contexts/support-link';
import {useApi} from '@/api';
import {blank, mapWithIndex} from '@/util';

const InfoList = ({data}) => {
  const infoList = mapWithIndex((item, idx) => <li key={idx}>{item}</li>)(
    data || []
  );
  return <ul>{infoList}</ul>;
};

const ProfileInfo = ({profile}) => {
  const {t: tr} = useTranslation('myProfile');

  return (
    <table className='info'>
      <tbody>
        <tr>
          <th>{tr('name')}</th>
          <td>{profile.name}</td>
        </tr>
        <tr>
          <th>{tr('phone_number')}</th>
          <td>
            <InfoList data={profile.phoneNumber} />
          </td>
        </tr>
        <tr>
          <th>{tr('email')}</th>
          <td>
            <InfoList data={profile.email} />
          </td>
        </tr>
        <tr>
          <th>{tr('res_address')}</th>
          <td>
            <InfoList data={profile.resAddress} />
          </td>
        </tr>
        <tr>
          <th>{tr('corr_address')}</th>
          <td>
            <InfoList data={profile.corrAddress} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const MailTo = () => {
  const mail = R.path(['myProfile', 'mailTo'], config);
  return <a href={`mailto:${mail}`}>{mail}</a>;
};

const MyProfile = () => {
  const [profile, error] = useApi('/b2c/profile');
  const {t: tr, i18n: i18nCtx} = useTranslation('myProfile');
  const {siteCode} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  if (error) {
    return (
      <div>
        <h1>Fail fetching data</h1>
        <p>{String(error)}</p>
      </div>
    );
  }

  return (
    <>
      <h1>{tr('title')}</h1>
      <p>{tr('for_company_only')}</p>
      <ProfileInfo profile={profile} />
      {i18nCtx.language === 'ja' && <p>{tr('need_to_update_personal_info')}</p>}
      {['kr', 'en', 'zh'].includes(i18nCtx.language) && (
        <>
          <p>
            {tr('need_to_update_personal_info')}
            <MailTo />
          </p>
          <p>
            {tr('for_enquiry')}
            <MainSiteLink
              href={supportLink.contactUs(siteCode)}
              target='_blank'
              rel='noopener noreferrer'
            >
              {tr('enquiry_link')}
            </MainSiteLink>
          </p>
        </>
      )}
    </>
  );
};

export default MyProfile;
